import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { QuizProvider } from "../../providers/quiz/quiz";
import { QuestionProvider } from '../../providers/question/question';
import { Quiz } from '../../models/quiz.model';
import { Question } from '../../models/question.model';
import { Choice } from '../../models/choice.model';
import { UserQuiz } from '../../models/user-quiz.model';

import { ProductDetailPage } from '../product-detail/product-detail';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-quiz-detail',
  templateUrl: 'quiz-detail.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class QuizDetailPage {

  quiz: Quiz;
  err: string;
  loading: boolean;

  currentQuestion: Question;
  currentQuestionIndex: number;
  currentChoices: Array<Choice>;

  currentAnswer: Array<Choice>;
  answered: boolean = false;

  quizFinished: boolean = false;
  userQuiz: UserQuiz;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public quizProvider: QuizProvider, public questionProvider: QuestionProvider) {}

  getQuiz() {
    this.loading = true;
    this.quizProvider.getByID(this.navParams.get('id'))
      .subscribe(
        quiz => {
          this.quiz = quiz;
          this.initQuiz();
        },
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  private check(questionID: number) {
    this.loading = true;
    this.questionProvider.check(questionID)
      .subscribe(
        choices => {
          if (choices) {
            this.currentQuestion.choices = choices;
            this.answered = true;
          }
        },
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  initQuiz() {
    // Clean current answer
    this.currentAnswer = [];
    // Clean current choices
    this.currentChoices = [];
    // Eeset question index
    this.currentQuestionIndex = 0;
    // Assign first question
    this.currentQuestion = this.quiz.questions[this.currentQuestionIndex];
    // check first question
    this.check(this.currentQuestion.id);
  }

  toggleChoice(choice: Choice) {
    let index = this.currentChoices.indexOf(choice);

    if (index === -1) {
        this.currentChoices.push(choice);
    } else {
        this.currentChoices.splice(index, 1);
    }
  }

  canValidate() {
    return this.currentChoices.length > 0;
  }

  isToggled(choice: Choice) {
    return this.currentChoices.indexOf(choice) > -1;
  }

  validate() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    this.questionProvider.sendAnswer(this.currentQuestion.id, this.currentChoices)
      .subscribe(
        choices => {
          this.currentQuestion.choices = choices;
        },
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_QUESTION_ANSWER'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          this.answered = true;
        }
      );
  }

  next() {
    // Increment current question
    this.currentQuestionIndex++;

    // Check if there another question
    if (this.currentQuestionIndex <= this.quiz.questions.length - 1) {
      this.nextQuestion();
    } else {
      this.finish();
    }
  }

  private finish() {
    // Request quiz/finish from the server
    this.loading = true;
    this.quizProvider.finish(this.navParams.get('id'))
      .subscribe(
        userQuiz => this.userQuiz = userQuiz,
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.displayScore();
        }
      );
  }

  private displayScore() {
    this.quizFinished = true;
    // Reset the current question to hide the quiz
    this.currentQuestion = new Question();
  }

  private nextQuestion() {
    // Reset answered status
    this.answered = false;
    // Clean current answer
    this.currentAnswer = [];
    // Clean current choices
    this.currentChoices = [];
    // Eeset question index
    this.currentQuestion = this.quiz.questions[this.currentQuestionIndex];
    // check first question
    this.check(this.currentQuestion.id);
  }

  public openProduct(id: number) {
    this.navCtrl.push(ProductDetailPage, {
      id: id
    });
  }

  ionViewDidLoad() {
    this.getQuiz();
  }

}



// WEBPACK FOOTER //
// ./src/pages/quiz-detail/quiz-detail.ts